import React from 'react';
import { cn } from '@/lib/utils';

interface PageLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const PageLayout = React.forwardRef<HTMLDivElement, PageLayoutProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        className={cn('min-h-screen bg-background text-foreground', className)}
        ref={ref}
        {...props}
      >
        {children}
      </div>
    );
  }
);
PageLayout.displayName = 'PageLayout';

const PageContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <main
    ref={ref}
    className={cn('container mx-auto py-8 px-4 md:px-6 lg:py-12', className)}
    {...props}
  />
));
PageContent.displayName = 'PageContent';

const PageTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h1
    ref={ref}
    className={cn(
      'text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl',
      className
    )}
    {...props}
  />
));
PageTitle.displayName = 'PageTitle';

const PageDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('text-lg text-muted-foreground mt-2', className)}
    {...props}
  />
));
PageDescription.displayName = 'PageDescription';

export { PageLayout, PageContent, PageTitle, PageDescription };
